var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ts-page-title',{attrs:{"title":_vm.$t('dashboard.pageTitle'),"sub-title":"header small text goes here...","breadcrumb":[
                { text: _vm.$t('home'), href: '/' },
                {
                    text: _vm.$t('dashboard.pageTitle'),
                    active: true
                }
            ]}}),_c('ts-panel',[_c('ts-panel-wrapper',[_c('div',{staticClass:"tw-w-full tw-flex tw-items-center tw-justify-center",staticStyle:{"height":"80vh"}},[_c('img',{staticStyle:{"height":"50%","width":"50%","object-fit":"contain"},attrs:{"src":"https://t4.ftcdn.net/jpg/00/89/02/67/360_F_89026793_eyw5a7WCQE0y1RHsizu41uhj7YStgvAA.jpg","alt":""}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }